/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { QuestionAnswerRowDto } from '../models';
// @ts-ignore
import type { StakeholderAnswersOverviewDto } from '../models';
// @ts-ignore
import type { UpsertQuestionAnswerDto } from '../models';
/**
 * DoubleMaterialityQuestionAnswersApi - axios parameter creator
 * @export
 */
export const DoubleMaterialityQuestionAnswersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dm/question-answers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerFindAllForStakeholder: async (stakeholderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderId' is not null or undefined
            assertParamExists('doubleMaterialityQuestionAnswersControllerFindAllForStakeholder', 'stakeholderId', stakeholderId)
            const localVarPath = `/api/dm/question-answers/by-stakeholder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stakeholderId !== undefined) {
                localVarQueryParameter['stakeholderId'] = stakeholderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stakeholderIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerOverview: async (stakeholderIds: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stakeholderIds' is not null or undefined
            assertParamExists('doubleMaterialityQuestionAnswersControllerOverview', 'stakeholderIds', stakeholderIds)
            const localVarPath = `/api/dm/question-answers/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (stakeholderIds !== undefined) {
                localVarQueryParameter['stakeholderIds'] = stakeholderIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpsertQuestionAnswerDto} upsertQuestionAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerUpsert: async (upsertQuestionAnswerDto: UpsertQuestionAnswerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertQuestionAnswerDto' is not null or undefined
            assertParamExists('doubleMaterialityQuestionAnswersControllerUpsert', 'upsertQuestionAnswerDto', upsertQuestionAnswerDto)
            const localVarPath = `/api/dm/question-answers/upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertQuestionAnswerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMaterialityQuestionAnswersApi - functional programming interface
 * @export
 */
export const DoubleMaterialityQuestionAnswersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMaterialityQuestionAnswersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionAnswersControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionAnswerRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionAnswersControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionAnswersApi.doubleMaterialityQuestionAnswersControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionAnswersControllerFindAllForStakeholder(stakeholderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionAnswerRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionAnswersControllerFindAllForStakeholder(stakeholderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionAnswersApi.doubleMaterialityQuestionAnswersControllerFindAllForStakeholder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} stakeholderIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionAnswersControllerOverview(stakeholderIds: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StakeholderAnswersOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionAnswersControllerOverview(stakeholderIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionAnswersApi.doubleMaterialityQuestionAnswersControllerOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpsertQuestionAnswerDto} upsertQuestionAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityQuestionAnswersControllerUpsert(upsertQuestionAnswerDto: UpsertQuestionAnswerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityQuestionAnswersControllerUpsert(upsertQuestionAnswerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityQuestionAnswersApi.doubleMaterialityQuestionAnswersControllerUpsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMaterialityQuestionAnswersApi - factory interface
 * @export
 */
export const DoubleMaterialityQuestionAnswersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMaterialityQuestionAnswersApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionAnswerRowDto>> {
            return localVarFp.doubleMaterialityQuestionAnswersControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stakeholderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerFindAllForStakeholder(stakeholderId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionAnswerRowDto>> {
            return localVarFp.doubleMaterialityQuestionAnswersControllerFindAllForStakeholder(stakeholderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stakeholderIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerOverview(stakeholderIds: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StakeholderAnswersOverviewDto>> {
            return localVarFp.doubleMaterialityQuestionAnswersControllerOverview(stakeholderIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpsertQuestionAnswerDto} upsertQuestionAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityQuestionAnswersControllerUpsert(upsertQuestionAnswerDto: UpsertQuestionAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityQuestionAnswersControllerUpsert(upsertQuestionAnswerDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoubleMaterialityQuestionAnswersApi - object-oriented interface
 * @export
 * @class DoubleMaterialityQuestionAnswersApi
 * @extends {BaseAPI}
 */
export class DoubleMaterialityQuestionAnswersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionAnswersApi
     */
    public doubleMaterialityQuestionAnswersControllerFindAll(options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionAnswersApiFp(this.configuration).doubleMaterialityQuestionAnswersControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stakeholderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionAnswersApi
     */
    public doubleMaterialityQuestionAnswersControllerFindAllForStakeholder(stakeholderId: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionAnswersApiFp(this.configuration).doubleMaterialityQuestionAnswersControllerFindAllForStakeholder(stakeholderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stakeholderIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionAnswersApi
     */
    public doubleMaterialityQuestionAnswersControllerOverview(stakeholderIds: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionAnswersApiFp(this.configuration).doubleMaterialityQuestionAnswersControllerOverview(stakeholderIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpsertQuestionAnswerDto} upsertQuestionAnswerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityQuestionAnswersApi
     */
    public doubleMaterialityQuestionAnswersControllerUpsert(upsertQuestionAnswerDto: UpsertQuestionAnswerDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityQuestionAnswersApiFp(this.configuration).doubleMaterialityQuestionAnswersControllerUpsert(upsertQuestionAnswerDto, options).then((request) => request(this.axios, this.basePath));
    }
}

